export default __webpack_public_path__ + "4d1173f3b3c5b72e166c6cea6fec2696.png";